import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, Platform } from 'ionic-angular';
import { App } from 'ionic-angular/components/app/app';
import { ToggleFavouriteService } from '../../provider/togglefavourite';
import { DealDetailsPage } from '../dealdetails/dealdetails';
import { DealsProviderService } from '../../provider/dealslistprovider';
import { LatLng, Spherical } from '@ionic-native/google-maps';
import { ConfigurationManager } from '../../provider/ConfigurationManager';
import * as Constants from '../../provider/Constants';
import { Network } from '@ionic-native/network';


/**
 * Generated class for the ParenttabsPage tabs.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'tab-page',
  templateUrl: 'tabpage.html',
})
export class TabPage implements OnInit {

  name = '';
  CurrentPage = 1;
  TotalPages: number;
  visible = false;
  patination = false;
  infiniteScroll = null;
  refresher = null;
  nodeals = false;
  loading;
  searchResultsEnable = false;
  searchparams = '';
  isNetworkConnected = true;

  private jsondata;
  private dealslist = [];
  rootNavCtrl: NavController;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    private appctrl: App,
    private service: DealsProviderService,
    private manager: ConfigurationManager,
    private toggle: ToggleFavouriteService,
    private platform: Platform,
    private network: Network,
    public loadingCtrl: LoadingController) {
    this.name = this.navParams.data.ScreenTitle;
    console.log('Passed params', this.navParams.data);
  }


  doRefresh(refresher) {
    this.dealslist = [];
    this.refresher = refresher;
    console.log('Begin async operation', refresher);
    /*  setTimeout(() => {
       console.log('Async operation has ended');
       refresher.complete();
     }, 2000); */
    this.getDeals(1);
  }

  swipeEvent(e) {
    console.log('swiped');
  }

  ngOnInit(): void {
    // this.searchVisibleData.poptabsmessage.subscribe(message => this.removeTab());


  }
  gotosearchResults(message) {
    if (message.searchres === true) {
      if (this.name === Constants.VACATIONS.params.name) {
        if (message.ScreenTitle === 'VACATIONS') {

          this.searchResultsEnable = true;
          this.searchparams = message;
        }

      }
    } else {
      this.searchResultsEnable = false;
    }

  }
  ionViewDidEnter() {
    // this.searchVisibleData.searchResultsMessage.subscribe(message => this.gotosearchResults(message));
    console.log('Enter view');
    this.dealslist = [];
    const isNetworkAvailable = this.checkDeviceNetworkConnection();
    if(!isNetworkAvailable) {
      this.removeLoader();
      this.visible = false;
      this.searchResultsEnable = false;
      this.isNetworkConnected = false;
      return;
    } 
    this.isNetworkConnected = true;
    this.getDeals(1);
    this.presentLoading();//??TODO uncomment later
  }

  ionViewWillLeave() {
    console.log('Leave view');

  }
  getDeals(pageno) {       
    this.service.getDeals(this.navParams.data, pageno).then(data => {

      console.log('status::::' + data.url);
      console.log('status::::' + data.status);
      console.log('data::::' + data.data); // data received by server
      console.log('data::::json' + JSON.parse(data.data));
      this.jsondata = JSON.parse(data.data);
      if (this.loading != null) {
        this.loading.dismiss();
      }

      const tempdeals = this.jsondata.Deals;
      this.dealslist = this.dealslist.concat(tempdeals);
      if (this.dealslist.length === 0) {
        this.nodeals = true;
      }
      this.CurrentPage = Number(this.jsondata.CurrentPage);
      this.TotalPages = this.jsondata.TotalPages;
      this.visible = true;

      this.CurrentPage === this.TotalPages ? this.patination = false : this.patination = true;

      if (this.infiniteScroll != null) {
        this.infiniteScroll.complete();
      }

      if (this.refresher != null) {
        this.refresher.complete();
      }

    })
      .catch(error => {

        console.log(error.status);
        console.log(error.error); // error message as string
        console.log(error.headers);
        if (this.infiniteScroll != null) {
          this.infiniteScroll.complete();

        }
        if (this.loading != null) {
          this.loading.dismiss();
        }
        if (this.infiniteScroll != null) {
          this.infiniteScroll.complete();
        }

      });
  }

  getDistance(tempdeal) {

    const lat = tempdeal.PartnerLocations[0].Latitude;
    const lng = tempdeal.PartnerLocations[0].Longitude;
    const lt = new LatLng(lat, lng);
    const lt2 = new LatLng(this.manager.getLatitude, this.manager.getLongitude);
    const distanceinmiles: number = Spherical.computeDistanceBetween(lt2, lt) / 1609.344;
    return distanceinmiles.toFixed(2) + ' mi';
  }

  isExpired(deal) {
    if (deal.DealTypeID !== 2 && deal.DealTypeID !== 3) {
      return false;
    }
    const date = new Date(deal.ExpirationDate);
    const now = new Date();
    const duration = date.valueOf() - now.valueOf();
    const diffDays = Math.ceil(duration / (1000 * 3600 * 24));
    deal.expiringdays = diffDays;
    return true;

  }

  expireddays(deal) {
    if (deal.expiringdays === 1) {
      return 'Expires in ' + deal.expiringdays + ' Day';
    } else if (deal.expiringdays <= 0) {
      return 'Expired';
    } else {
      return 'Expires in ' + deal.expiringdays + ' Days';
    }

  }

  getFlagImage(deal) {
    if (deal.RecommendedFlag) {
      return 'assets/savingsimg/img_recommended_deal_flag.png';
    } else if (deal.FeaturedFlag) {
      return 'assets/savingsimg/img_featured_deal_flag.png';
    } else if (deal.DealOfWeekFlag) {
      return 'assets/savingsimg/img_hot_deal_flag.jpg';
    }
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({

    });

    this.loading.present();

  }


  clickevent(deal) {
    this.appctrl.getRootNavs()[0].push(DealDetailsPage,
      {
        'Latitude': this.manager.getLatitude, 'Longitude': this.manager.getLongitude, 'DealID': deal.DealID, 'CustomerToken': this.manager.getCustomerToken,
        'ProxyUI': this.manager.getProxyUI, 'ClubCode': this.manager.getClubCode, 'EnvironmentName': this.manager.getEnvironmentName, 'ZipCode': '48126'
      });
  }

  doInfinite(infiniteScroll) {
    console.log('Begin async operation');

    this.getDeals(this.CurrentPage + 1);
    this.infiniteScroll = infiniteScroll;

    /*  setTimeout(() => {
       console.log('Async operation has ended');
       infiniteScroll.complete();
     }, 500); */
  }

  favourite(dealid, flagg, deall, i) {

    this.toggle.setFavourite(this.dealslist[i]).then(data => {
      const jsondata = JSON.parse(data.data);
      jsondata.FavoritePartnerFlag === true ? this.dealslist[i].FavoritePartnerFlag = true :
      this.dealslist[i].FavoritePartnerFlag = false;
    })
      .catch(error => {

        console.log(error.status);
        console.log(error.error); // error message as string
        console.log(error.headers);

      });
  }

  checkDeviceNetworkConnection():boolean {
    if (this.platform.is('cordova')) {
      const isNetworkAvailable = (this.network.type === 'none') ? false : true;
      return isNetworkAvailable;
    }
  }
  removeLoader() {
    if (this.loading != null) {
      this.loading.dismiss();
    }
    if (this.infiniteScroll != null) {
      this.infiniteScroll.complete();
    }
  }

}

